import { isNotNilOrEmpty } from "client/Misc/utils";

export function combineStyles(...styleObjects: readonly { [key: string]: string; }[]): string | undefined {
	const resultObject: { [key: string]: string; } = Object.assign(
		{},
		...styleObjects
	);

	const keys: string[] = Object.keys(resultObject);
	if (keys.length === 0) {
		return undefined;
	}

	return keys
		.filter(k => isNotNilOrEmpty(resultObject[k]))
		.map(k => `${k}: ${resultObject[k]}`)
		.join(";");
}